<script setup lang="ts">
const props = defineProps({
    options: {
        type: Object as PropType<IntersectionObserverInit>,
        default: undefined
    },
    class: {
        type: [String, Object] as PropType<string | object>,
        required: false,
        default: ''
    }
});

const emit = defineEmits<{
    intersect: [];
}>();

const observer = ref();
const observerElement = ref(null);
const onView = ref(false);

onMounted(() => {
    const options = props.options || {
        rootMargin: '100px 0px'
    };
    observer.value = new IntersectionObserver(([entry]) => {
        if (entry && entry.isIntersecting) {
            emit('intersect');
            onView.value = true;
        }
    }, options);
    observer.value.observe(observerElement.value);
});

onUnmounted(() => {
    if (observer.value) {
        observer.value.disconnect();
    }
});
</script>

<template>
    <slot v-if="!onView" name="preload"></slot>
    <div ref="observerElement" data-observer :class="props.class">
        <slot v-if="onView"></slot>
    </div>
</template>
